import {
  faCheck,
  faChevronRight,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';

export const WORKFLOW_ICONS = [faCheck, faChevronRight, faInfoCircle];
